// Thin wrapper over the PostHog snippet in public/index.html. Safe when the
// snippet is blocked or not loaded yet.
export function track(event, properties = {}) {
  try {
    window.posthog?.capture?.(event, properties);
  } catch {
    // Analytics must never break a click.
  }
}
